module.exports = __webpack_public_path__ + "img/details-bloggers.png?2e01d12977e0be2fbf6dd66c7026430f";